import { Injectable, signal } from "@angular/core";
import { UnitPreferences } from '../../shared/data/models/UnitPreferences';
import { BTU_PER_HOUR, BTU_SMALL, GAL, KW, KW_SMALL, L } from "../constants/common.constants";
import { User } from "../data/models/User";


@Injectable({ providedIn: 'root' })
export class UnitPreferenceService {
  unitPreferences = signal<UnitPreferences | null>(null);

  setUnitPreferences(user: User): void {
    this.unitPreferences.set({
      temperatureUnit: user.temperatureUnit ?? '',
      dimensionUnit: user.dimensionUnit ?? '',
      weightUnit: user.weightUnit ?? '',
      volumeUnit: user.volumeUnit?.toLowerCase() == GAL ? GAL : L,
      capacityUnit: user.capacityUnit?.toLowerCase() == KW_SMALL.toLowerCase() ? KW : (user.capacityUnit?.toLowerCase() == BTU_SMALL.toLowerCase() ? BTU_PER_HOUR : '')
    });
    sessionStorage.setItem('unitPreferences', JSON.stringify(this.unitPreferences()!));
  }

  getUnitPreferences(): UnitPreferences | null {
    return this.unitPreferences()? this.unitPreferences() : JSON.parse(sessionStorage.getItem('unitPreferences') || 'null');
  }
}